import React, { useRef } from 'react'
import Barcode from './Barcode'
import { useReactToPrint } from "react-to-print";
import { IoPrint } from 'react-icons/io5';


const PrintFrontSlip = ({ orders = [] }) => {


    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });



    // orders ko 3-3 ke groups me split karo
    const chunkedOrders = []
    for (let i = 0; i < orders.length; i += 2) {
        chunkedOrders.push(orders.slice(i, i + 2))
    }

    return (
        <>

            {/* Internal Print CSS */}
            <style>
                {`
                @media print {

                    @page {
                        size: A4;
                        margin: 0;
                    }

                    .print-page {
                        page-break-after: always;
                        padding: 10px;
                    }

                    .print-page:last-child {
                        page-break-after: auto;
                    }

                    .single-slip {
                        height: 50%;
                    }
                }
                `}
            </style>

            <div className="">
                <button
                    onClick={reactToPrintFn}
                    className="oms-btn oms-btn-primary"
                >
                    <IoPrint />
                    Print Slip
                </button>

                <div className="print-wrapper printContent" ref={contentRef}>
                    {chunkedOrders.map((pageOrders, pageIndex) => (
                        <div className="print-page" key={pageIndex}>

                            {pageOrders.map((item, i) => (
                                <div className="row g-0 single-slip mb-2" key={item?.id || i}>
                                    <div className="border border-2 border-dark">

                                        {/* Receiver */}
                                        <div className="col-12">
                                            <div className="border-bottom border-dark fw-bold text-center">
                                                Receiver Detail
                                            </div>

                                            <div className="row px-1">
                                                <div className="col-6 fw-bold">


                                                    <Barcode orderId={item?.trackingId} />
                                                    {/* order ID : {item?.trackingId} */}
                                                </div>

                                                <div className="col-6 text-end fw-bold">
                                                    Amount : {
                                                        item?.amount
                                                            ? (Number(item.amount) < 10000
                                                                ? Number(item.amount) - 75
                                                                : Number(item.amount) - 100)
                                                            : 0
                                                    }
                                                </div>

                                            </div>

                                            <div className="p-2">
                                                <p><b>Name:</b> {item?.customerName}</p>
                                                <p><b>Address:</b> {item?.address}</p>
                                                <p><b>Contact:</b> {item?.phoneNumber}</p>
                                                <p><b>City:</b> {item?.city}</p>
                                            </div>
                                        </div>

                                        {/* Sender */}
                                        <div className="col-12">
                                            <div className="border-bottom border-dark fw-bold text-center"></div>

                                            <div className="row align-items-center">
                                                <div className="col">

                                                    <div className="text-center fw-bold p-2" style={{ fontSize: "14px" }}>
                                                        (Bulk User) AR E-Cart
                                                        P.O Box No. 2110
                                                        <br />
                                                        Nazimabad HPO
                                                        Karachi
                                                        <br />
                                                        0300-4919318
                                                        <br />
                                                        {" موجود ہے۔ شکریہ۔ (CNIC) پارسل کی بروقت اور یقینی ترسیل کو ممکن بنائیں۔"}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))}

                        </div>
                    ))}
                </div>

            </div>
        </>
    )
}

export default PrintFrontSlip
